export default __webpack_public_path__ + "mobile_top_scribbler.093c47.png";